// Soft two-tone ring using WebAudio; returns a stop() function.
export function startRingtone() {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return () => {};
    const ctx = new Ctx();
    const beep = () => {
        [0, 0.35].forEach((offset, i) => {
            const o = ctx.createOscillator();
            const g = ctx.createGain();
            o.frequency.value = i ? 660 : 880;
            g.gain.setValueAtTime(0.0001, ctx.currentTime + offset);
            g.gain.exponentialRampToValueAtTime(0.15, ctx.currentTime + offset + 0.03);
            g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + offset + 0.3);
            o.connect(g).connect(ctx.destination);
            o.start(ctx.currentTime + offset);
            o.stop(ctx.currentTime + offset + 0.32);
        });
    };
    beep();
    const t = setInterval(beep, 2000);
    if (navigator.vibrate) navigator.vibrate([300, 200, 300]);
    return () => { clearInterval(t); ctx.close().catch(() => {}); };
}
